export default {
  intro: 'Introduction',
  pillars: [
    {
      key: 'community-equity-and-justice',
      title: 'Community Equity & Justice'
    },
    {
      key: 'strong-healthy-homes',
      title: 'Strong, Healthy Homes'
    },
    {
      key: 'financial-strength',
      title: 'Financial Strength'
    },
    {
      key: 'aging-in-community',
      title: 'Aging in Community'
    },
    {
      key: 'climate-justice',
      title: 'Climate Justice'
    }
  ],
  about: 'About',
  contact: 'Contact'
};
